import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CercadorEsplaisComponent } from './cercador-esplais/cercador-esplais.component';
import { CercadorActivitatsComponent } from './cercador-activitats/cercador-activitats.component';

const routes: Routes = [
  {
  path: 'esplais',
  component: CercadorEsplaisComponent,
},
{
  path: 'activitats',
  component: CercadorActivitatsComponent,
}
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    )],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
